import * as React from 'react';
import { toast } from 'react-toastify';
import { PageHeaderWrap, PageWrapper } from '../studentHome/styles';
import { NoData, PageHeader } from '../../components';
import { SearchToViewTimetable, Timetable } from './components';
import { useMutation } from '@apollo/client';
import { PageLoader } from '../../helpers';
import { GetInvigilatorPapersMutation } from '../../generated/graphql';
import { GET_INVIGLATOR_PAPERS } from './graphql';
import { Helmet } from 'react-helmet';

export const InvigilatorHome = (): JSX.Element => {
  // to show either timetable or no timetable
  const [show, setShow] = React.useState<boolean>(false);
  const [showTimetable, setShowTimetable] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string>('');

  const [getIngivilatorPapers, { loading, data }] =
    useMutation<GetInvigilatorPapersMutation>(GET_INVIGLATOR_PAPERS);

  const handleSearch = async (): Promise<void> => {
    if (searchValue === '') {
      setShow(false);
      toast.error(`Please you must provide search term before!`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'text-white bg-red-500',
      });
      return;
    } else {
      try {
        // make a request to the backend with this search value
        await getIngivilatorPapers({ variables: { name: searchValue.trim() } });
        setShow(true);
        setShowTimetable(true);
        toast.success('Timetable found!');
      } catch (err) {
        toast.error(
          err?.message || `Your schedule was not found! Please contact coe exams office`,
          {
            position: 'top-right',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            progressStyle: { backgroundColor: '#ffccbb' },
            draggable: true,
            className: 'text-white bg-red-500',
            style: { width: '90%', marginLeft: '2rem', borderRadius: '10px', marginTop: '1rem' },
          },
        );
        setShow(true);
        setShowTimetable(false);
      }
    }
  };

  if (loading) return <PageLoader />;

  return (
    <PageWrapper>
      <Helmet>
        <title>KNUST, CoE Check timetable for Invigilators</title>
        <meta
          name="invigilator-check-timetable"
          content="Home page for KNUST,college of engineering invigilators
           to check timetable schedule"
        />
      </Helmet>
      <PageHeaderWrap>
        <PageHeader />
      </PageHeaderWrap>
      <SearchToViewTimetable
        handleSubmit={handleSearch}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      {show ? (
        showTimetable ? (
          <Timetable timetable={data} />
        ) : (
          <NoData
            title="your schedule was not found"
            subtitle="Please visit the exams office to resolve this issue"
          />
        )
      ) : null}
    </PageWrapper>
  );
};
